import { useMemo } from "react";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import PubSub from "../../services/PubSub";
import Utils from "../../utils/utils";
import Icon from "./Icon";

const UploadArea = ({
    heading,
    dropText = "OTM_DROP_FILES",
    dragText = "OTM_DRAG_FILES",
    parentId,
    uploadCallback = () => {},
    responseCallback = () => {},
    disabled = false,
    icon = "CloudUpload"
}) => {
    const [translate] = useTranslation();

    const onDrop = useCallback(async (acceptedFiles) => {
        PubSub.publish("show_spinner");
        const data = new FormData();
        const paths = {};
        acceptedFiles.forEach(file => {
            const fileId = Utils.generateId();
            paths[fileId] = file.path;
            data.append("files", file, fileId);
        });
        data.append("path", JSON.stringify(paths));

        const response = await uploadCallback(parentId, data);

        if (!response.error) {
            responseCallback(parentId);
        }
        else {
            PubSub.publish("hide_spinner");
        }
    }, [parentId, uploadCallback, responseCallback]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, noClick: disabled });

    const dropZone = useMemo(() => {
        return (
            <>
                {heading && <label className="d-block form-label h6">{translate(heading)}</label>}
                <div {...getRootProps()} className={disabled ? 'dropzone-disabled' : 'dropzone'}>
                    <input {...getInputProps()} />
                    <div className="form-control bg-light p-1 d-flex flex-column justify-content-center text-center">
                        <p className="m-0">
                            {isDragActive ? translate(dropText) : translate(dragText)}
                        </p>
                        <Icon icon={icon} className="fs-1 mx-auto" />
                    </div>
                </div>
            </>
        );
    }, [isDragActive, dragText, dropText, disabled, heading, translate, getRootProps, getInputProps, icon]);

    return (
        <>
            {dropZone}
        </>
    );
};

export default UploadArea;